// import React, { Component } from "react";
// import { connect } from "react-redux";
// import Webcam from "react-webcam";
// import { changeView, setIdCaptureImage } from "../actions/assessment";
// import { Translate } from "react-redux-i18n";
// import { SaveUserStateToServerHelper } from "./Helper";
// import axios from "axios";
// import config from "../config/config-secret.json";

// export class IdCapture extends Component {
//   constructor(props) {
//     super(props);

//     this.webcamRef = React.createRef();
//   }

//   handleRetakePhoto = () => {
//     this.props.setIdCaptureImage(null);
//     SaveUserStateToServerHelper({
//       ...this.props.assessment,
//       id_capture_fields: { image: null },
//     });
//   };

//   handleCapture = async () => {
//     const imageb64 = this.webcamRef.current.getScreenshot();
//     const taken_at = new Date();

//     await axios
//       .post(config.API_URL + `/administer_test/save_id_image/`, {
//         imageb64,
//         taken_at,
//         tester_id: this.props.assessment.tester_id,
//       })
//       .then(async (res) => {
//         this.props.setIdCaptureImage(
//           `${config.API_DOMAIN}${res.data.data.url}`
//         );
//         SaveUserStateToServerHelper({
//           ...this.props.assessment,
//           id_capture_fields: { image: res.url },
//         });
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };

//   handleContinue = () => {
//     if (Object.keys(this.props.demographic_fields).length > 0) {
//       this.props.continue("demographic");
//     } else if (Object.keys(this.props.sport_demographic_fields).length > 0) {
//       this.props.continue("sport_demographic");
//     } else {
//       this.props.continue("session_details");
//     }
//   };

//   onUserMediaError = () => {
//     alert("Can't access webcam, please contact administrator.");
//   };

//   onUserMedia = () => {};

//   componentDidMount() {
//     SaveUserStateToServerHelper(this.props.assessment);
//   }

//   render() {
//     const hasImageTaken =
//       this.props.id_capture_fields && this.props.id_capture_fields.image;

//     return (
//       <div className="main container-fluid h-100">
//         <div className="row h-100 justify-content-center align-items-center">
//           <div className="col-12">
//             <div className="container">
//               <div className="row  justify-content-center ">
//                 <div className="col-md-10">
//                   <div className="test-info ">
//                     <h3 className="mt-4 mb-3 text-center">
//                       <Translate value="id_capture_header" />
//                     </h3>
//                     <p className="mb-4">
//                       <Translate value="id_capture_instructions_2" />
//                     </p>
//                     {hasImageTaken ? (
//                       <img
//                         className="col-12 mb-4"
//                         alt=""
//                         style={{
//                           backgroundColor: "black",
//                           border: "solid 2px yellow",
//                           borderRadius: "8px",
//                         }}
//                         src={this.props.id_capture_fields.image}
//                       />
//                     ) : (
//                       <Webcam
//                         className="col-12 mb-4"
//                         style={{
//                           backgroundColor: "black",
//                           border: "solid 2px yellow",
//                           borderRadius: "8px",
//                         }}
//                         ref={this.webcamRef}
//                         onUserMediaError={this.onUserMediaError}
//                         onUserMedia={this.onUserMedia}
//                       />
//                     )}

//                     <div className="button-wrap">
//                       {hasImageTaken ? (
//                         <>
//                           <button
//                             onClick={this.handleRetakePhoto}
//                             className="btn btn-outline-secondary btn-xl btn-block"
//                           >
//                             <Translate value="retake_photo" />
//                           </button>

//                           <button
//                             className="btn btn-main btn-global btn-block"
//                             onClick={this.handleContinue}
//                           >
//                             <Translate value="cont" />
//                           </button>
//                         </>
//                       ) : (
//                         <button
//                           className="btn btn-main btn-global btn-block"
//                           onClick={this.handleCapture}
//                         >
//                           <Translate value="capture" />
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// const mapStateToProps = (state) => ({
//   ...state,
//   demographic_fields: state.assessment.demographic_fields,
//   sport_demographic_fields: state.assessment.sport_demographic_fields,
//   id_capture_fields: state.assessment.id_capture_fields,
// });

// const mapDispatchToProps = (dispatch) => ({
//   continue: (view) => dispatch(changeView(view)),
//   setIdCaptureImage: (imageb64, takenAt) =>
//     dispatch(setIdCaptureImage(imageb64, takenAt)),
// });

// export default connect(mapStateToProps, mapDispatchToProps)(IdCapture);

import React, { Component } from "react";
import { connect } from "react-redux";
import Webcam from "react-webcam";
import axios from "axios";
import { Translate } from "react-redux-i18n";

import { changeView, setIdCaptureImage } from "../actions/assessment";
import { SaveUserStateToServerHelper } from "./Helper";
import config from "../config/config-secret.json";
import Button from "./ui/Buttons/Button";

const CAMERA_STYLE = {
  backgroundColor: "black",
  border: "solid 2px yellow",
  borderRadius: "8px",
};

export class IdCapture extends Component {
  webcamRef = React.createRef();

  componentDidMount() {
    SaveUserStateToServerHelper(this.props.assessment);
  }

  handleRetakePhoto = () => {
    this.props.setIdCaptureImage(null);

    SaveUserStateToServerHelper({
      ...this.props.assessment,
      id_capture_fields: { image: null },
    });
  };

  handleCapture = async () => {
    try {
      const imageb64 = this.webcamRef.current?.getScreenshot();
      if (!imageb64) return;

      const taken_at = new Date();

      const res = await axios.post(
        `${config.API_URL}/administer_test/save_id_image/`,
        {
          imageb64,
          taken_at,
          tester_id: this.props.assessment.tester_id,
        },
      );

      const imageUrl = `${config.API_DOMAIN}${res.data.data.url}`;

      this.props.setIdCaptureImage(imageUrl);

      SaveUserStateToServerHelper({
        ...this.props.assessment,
        id_capture_fields: { image: imageUrl },
      });
    } catch (error) {
      console.error("ID capture failed:", error);
    }
  };

  handleContinue = () => {
    const {
      demographic_fields,
      sport_demographic_fields,
      continue: go,
    } = this.props;

    if (Object.keys(demographic_fields).length > 0) {
      go("demographic");
    } else if (Object.keys(sport_demographic_fields).length > 0) {
      go("sport_demographic");
    } else {
      go("session_details");
    }
  };

  onUserMediaError = () => {
    alert("Can't access webcam, please contact administrator.");
  };

  renderPreview() {
    const { id_capture_fields } = this.props;
    const hasImage = Boolean(id_capture_fields?.image);

    if (hasImage) {
      return (
        <img
          className="col-12 mb-4"
          alt=""
          style={CAMERA_STYLE}
          src={id_capture_fields.image}
        />
      );
    }

    return (
      <Webcam
        className="col-12 mb-4"
        style={CAMERA_STYLE}
        ref={this.webcamRef}
        onUserMediaError={this.onUserMediaError}
      />
    );
  }

  renderActions() {
    const hasImage = Boolean(this.props.id_capture_fields?.image);

    if (hasImage) {
      return (
        <div className="d-flex w-100 flex-column flex-md-row">
          <Button
            variant="outline"
            className="flex-fill mr-md-3 mb-3 mb-md-0"
            onClick={this.handleRetakePhoto}
          >
            <Translate value="retake_photo" />
          </Button>

          <Button
            variant="primary"
            className="flex-fill"
            onClick={this.handleContinue}
          >
            <Translate value="cont" />
          </Button>
        </div>
      );
    }

    return (
      <Button
        variant="primary"
        className="btn-block"
        onClick={this.handleCapture}
      >
        <Translate value="capture" />
      </Button>
    );
  }

  render() {
    return (
      <div className="main container-fluid h-100">
        <div className="row h-100 justify-content-center align-items-center">
          <div className="col-12">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-10">
                  <div className="test-info">
                    <h3 className="mt-4 mb-3 text-center">
                      <Translate value="id_capture_header" />
                    </h3>

                    <p className="mb-4">
                      <Translate value="id_capture_instructions_2" />
                    </p>

                    {this.renderPreview()}

                    <div className="button-wrap">{this.renderActions()}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  assessment: state.assessment,
  demographic_fields: state.assessment.demographic_fields,
  sport_demographic_fields: state.assessment.sport_demographic_fields,
  id_capture_fields: state.assessment.id_capture_fields,
});

const mapDispatchToProps = (dispatch) => ({
  continue: (view) => dispatch(changeView(view)),
  setIdCaptureImage: (image) => dispatch(setIdCaptureImage(image)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IdCapture);
